import { render, staticRenderFns } from "./management.vue?vue&type=template&id=ab9933e2&scoped=true&"
import script from "./management.vue?vue&type=script&lang=js&"
export * from "./management.vue?vue&type=script&lang=js&"
import style0 from "./management.vue?vue&type=style&index=0&id=ab9933e2&lang=scss&scoped=true&"
import style1 from "./management.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9933e2",
  null
  
)

export default component.exports